<div class="main-container">
  <section class="top-section">
    <img src="assets/logo/logo-full-green.png" alt="check plus logo" />
  </section>

  <section class="slide-container">
    <img src="/assets/sing-up/1.png" alt="" />
  </section>

  <section class="sing-up-title-wrapper">
    <h1>Create an account</h1>
    <label for="">Let’s get started with your basic info </label>
  </section>

  <section class="form">
    <div class="company" [formGroup]="form">
      <div class="companies-forms">
        <div class="input-container">
          <label class="input-label">First Name</label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !form.controls['firstName'].valid &&
                form.controls['firstName'].touched
            }"
            formControlName="firstName"
            placeholder="Enter your first name"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['firstName'].valid &&
              form.controls['firstName'].touched
            "
          >
            Required
          </label>
        </div>

        <div class="input-container">
          <label class="input-label">Last Name</label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !form.controls['lastName'].valid &&
                form.controls['lastName'].touched
            }"
            formControlName="lastName"
            placeholder="Enter your last name"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['lastName'].valid &&
              form.controls['lastName'].touched
            "
          >
            Required
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Email</label>
          <gbui-input
            class="inputs"
            simple
            (keyup)="emailToLowercase($event)"
            [ngClass]="{
              'invalid-input':
                !form.controls['email'].valid && form.controls['email'].touched
            }"
            formControlName="email"
            placeholder="Enter your email"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['email'].valid && form.controls['email'].touched
            "
          >
            Invalid Email
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Job Title (Optional)</label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !form.controls['jobTitle'].valid &&
                form.controls['jobTitle'].touched
            }"
            formControlName="jobTitle"
            placeholder="Enter company job title"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['jobTitle'].valid &&
              form.controls['jobTitle'].touched
            "
          >
            Required
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Department (Optional)</label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !form.controls['department'].valid &&
                form.controls['department'].touched
            }"
            formControlName="department"
            placeholder="Enter company department"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['department'].valid &&
              form.controls['department'].touched
            "
          >
            Required
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Company Name</label>
          <input
            class="simulate-input"
            type="text"
            [ngClass]="{
              'invalid-input':
                (!form.controls['companyName'].valid &&
                  form.controls['companyName'].touched) ||
                companyExists
            }"
            formControlName="companyName"
            placeholder="Enter company name here"
            (blur)="onCompanyNameChange($event)"
          />
          <div class="loader-icon-wrapper">
            <ng-template
              [ngIf]="
                isValid &&
                companyExists == '' &&
                !(validateCompanyName$ | async)
              "
            >
              <img src="/assets/icons/check.svg" alt="" />
            </ng-template>

            <ng-template [ngIf]="(validateCompanyName$ | async) ?? false">
              <mat-spinner [diameter]="20" class="mat-spinner-green">
              </mat-spinner>
            </ng-template>
          </div>

          <label
            class="scale-up-ver-top"
            *ngIf="
              (!form.controls['companyName'].valid &&
                form.controls['companyName'].touched) ||
              companyExists
            "
          >
            {{ companyExists ? companyExists : "Required" }}
          </label>
        </div>
      </div>
      <h3 class="set-password-title">Set your password</h3>
      <div class="companies-forms">
        <div class="input-container">
          <label class="input-label">New Password</label>
          <gbui-input
            class="inputs"
            password
            [ngClass]="{
              'invalid-input':
                !form.controls['password'].valid &&
                form.controls['password'].touched
            }"
            formControlName="password"
            placeholder="Enter your new password"
          >
          </gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['password'].valid &&
              form.controls['password'].touched
            "
          >
            {{ getPasswordErrorMessage('password') }}
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Confirm New Password</label>
          <gbui-input
            class="inputs"
            password
            formControlName="confirmPassword"
            placeholder="Confirm your new password"
            [ngClass]="{
              'invalid-input':
                !form.controls['confirmPassword'].valid &&
                form.controls['confirmPassword'].touched
            }"
          >
          </gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['confirmPassword'].valid &&
              form.controls['confirmPassword'].touched
            "
          >
            {{ getPasswordErrorMessage('confirmPassword') }}
          </label>
        </div>
      </div>
    </div>
  </section>

  <section class="button-container">
    <div class="">
      <gbui-button
        [disabled]="form.invalid || companyExists !== ''"
        [busy]="(createManagerLoading$ | async) ?? false"
        (click)="create()"
        >Create account</gbui-button
      >

      <label class="sign-in"
        >Already have an account?
        <span routerLink="/authentication/sign-in">Sign in</span></label
      >
    </div>
  </section>
</div>
